import { Directive, HostListener, Self } from '@angular/core';
import { BaseChartDirective } from 'ng2-charts';

// tslint:disable-next-line:directive-selector
@Directive({ selector: 'canvas[baseChart]' })
export class ChartEscapeDirective {
  constructor(@Self() private readonly baseChart: BaseChartDirective) {}

  @HostListener('document:keydown.escape')
  onEscape(): void {
    const chart = this.baseChart?.chart as any;
    if (!chart) { return; }
    const tooltip = chart.tooltip;
    if (!tooltip) { return; }
    tooltip._active = [];
    tooltip.update(true);
    chart.draw();
  }
}
